// 路由权限仓库

import {constantRouterMap} from '@/router'

//该导入方法已废弃
// const _import = require('../../router/import_' + process.env.NODE_ENV);
/**
 * 递归过滤异步路由表，返回符合用户角色权限的路由表
 * @param routeArr
 */
function filterAsyncRouter(data) {
  for(let [i,v] of data.entries()){
    if(v.comAdd !== ""){
      try {
        // 判断本地是否存在该组件
        // v.component = _import(v.comAdd);
        v.component = () => import(`@/views/${v.comAdd}.vue`);
      } catch(e) {
        throw new Error(e)
      }
    }
    if (v.children && v.children.length) {
      v.children = filterAsyncRouter(v.children)
    }
  }
  return data;
}
/**
 * 获取异步路由表
 * @param roles
 *
 */
function getAsyncRouter(roles) {
  return filterAsyncRouter(roles);
}

const permission = {
  state: {
    routers: constantRouterMap,
    addRouters: [],
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers
      state.routers = constantRouterMap.concat(routers)
    },
    SET_CLEAR_PERMISSION:(state)=> {
      state.addRouters = [];
      state.routers =constantRouterMap;
    },

  },
  actions: {
    GenerateRoutes({commit}, routerdata) {
      return new Promise(resolve => {
        let accessedRouters = getAsyncRouter(routerdata)
        // 添加404页面
        accessedRouters.push( {path: '*', redirect: '/404',comAdd:'',hidden: 'true',noDropdown: 'false'})
        commit('SET_ROUTERS', accessedRouters)
        resolve()
      })
    },
    ClearPermission({commit}){
      commit('SET_CLEAR_PERMISSION');
    }
  }
}

export default permission



// WEBPACK FOOTER //
// ./src/store/modules/permission.js